<template>
  <el-table v-if="cutView=='report'" stripe border style="width: 100%" height="100%" size="mini"
    :data="tableData">
    <el-table-column type="index" align="center"
      :width="pagination.endIndex >= 1000 ? 80 : 50"
      :index="pagination.beginIndex"
    ></el-table-column>
    <el-table-column min-width="100px"
      label="报工日期" align="center" prop="allowSkip" show-overflow-tooltip>
      <template slot-scope="scope">
        {{ scope.row.createDate ? scope.row.createDate : '-' }}
      </template>
    </el-table-column>
    <el-table-column
      label="工厂名称" align="center" prop="allowSkip" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>
          {{ scope.row.werks ? scope.row.werks : '-' }}
        </span>
      </template>
    </el-table-column>
    <el-table-column min-width="120px"
      label="工单号" prop="adrcName1" align="center" show-overflow>
      <template slot-scope="scope">
          <span class="textOverflow">
            {{ scope.row.aufnr ? scope.row.aufnr : '-' }}
          </span>
      </template>
    </el-table-column>
    <el-table-column
      label="工单数量" align="center" prop="sn" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{ scope.row.psmng ? scope.row.psmng : '-' }}</span>
      </template>
    </el-table-column>
      <el-table-column
        label="工厂型号" align="center" prop="createDate" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.model ? scope.row.model : '-' }}</span>
        </template>
      </el-table-column>
    <el-table-column
        label="报工标识" align="center" prop="zc0011" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.cflag ? scope.row.cflag : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="工作中心" align="center" prop="createUser" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.arbpl ? scope.row.arbpl : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="线别" align="center" prop="createDate" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.ktext ? scope.row.ktext : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="工序类别" align="center" prop="createDate" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.steus ? scope.row.steus : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="人数" align="center" prop="createDate" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.overtime">{{ scope.row.anzma ? scope.row.anzma+'(加班)' : '-' }}</span>
          <span v-else>{{ scope.row.anzma ? scope.row.anzma : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="工时" align="center" prop="createDate" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.ism01 ? scope.row.ism01 : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="标准产能" align="center" prop="createDate" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.capacity ? scope.row.capacity : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="报工产能" align="center" prop="createDate" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.mnga ? scope.row.mnga : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="不良品" align="center" prop="createDate" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.defectiveMnga ? scope.row.defectiveMnga : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="综合效率" align="center" prop="createDate" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.efficiency ? scope.row.efficiency : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="135px"
        label="拉长" align="center" prop="createDate" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.employeeName ? scope.row.employeeName : '-' }}</span>
        </template>
      </el-table-column>      
  </el-table>
</template>
<script>
import {
  apiSapOrderReportedSearch2
} from "@/api/SapOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
    cutView:null,
    searchConditionForm:{type: Object},
    pagination:{}
  },
  computed: {
  },
  components: {
  },
  created() {
  },
  data() {
    return {
      dialogTitle: "【未命名】",
      dialogForm: {
      },
      tableData:null,
      dialogRules: {},
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {
    clickAllowSkip(row) {
      let tabPaneIds = this.$parent.tabPaneList2.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.$parent.tabPaneList2.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.$parent.tabPaneList2.push(row);
      }
    },
    async onSearch(callback) {
      this.tableData = [];
      const res = await apiSapOrderReportedSearch2({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      });
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) {callback();}
      }
    }
  }
};
</script>